module.exports = __webpack_public_path__ + "static/media/instagram.647e8705.svg";